export default __webpack_public_path__ + "static/media/photo--sm--100.c4770123.jpg";